import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { AlertProps } from '../../interface';

export const useAlert = ({
  condition = true,
  message,
  variant = 'error',
}: AlertProps) => {
  useEffect(() => {
    if (condition) {
      enqueueSnackbar(message, { variant: variant });
    }
  }, [condition, message, variant]);
};
